import React from 'react';
import styles from './styles.module.css';
import { SearchResultCard, AdvisedFilter, SortByLine } from '../index';
import Explore from '../Explore';
import hotel1 from './hotel1.jpg';
import hotel2 from './hotel2.jpg';

const SearchResultMain = () => {
  return (
    <div className={styles.main}>
      <Explore/>
      <SortByLine />
      <AdvisedFilter />
      <SearchResultCard img={hotel1}/>
      <SearchResultCard img={hotel2}/>
      <SearchResultCard img={hotel1}/>
    </div>
  );
};
export default SearchResultMain;
